import React, { useState, useEffect } from "react";
import { Layout, Row, Col } from "antd";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

const { Footer, Content } = Layout;

export const FooterInterno = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const { id_asociacion } = useParams();
  const [asociaciones, setAsociaciones] = useState([]);
  const [asociacionActiva, setAsociacionActiva] = useState(null);

  //Buscar asociación para traer la imagen
  useEffect(() => {
    fetchAsociaciones();
  }, [sesion.id_asociacion]);

  const fetchAsociaciones = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOMINIO}/asociaciones-publicas`
      );
      if (response.status === 200) {
        const asociacionesData = response.data;
        setAsociaciones(asociacionesData);
        if (asociacionesData) {
          const foundAsoc = asociacionesData.find(
            (asoc) => asoc.id === sesion.id_asociacion
          );
          if (foundAsoc) {
            setAsociacionActiva(foundAsoc);
            return;
          }
        }

        // setAsociacionActiva(asociacionesData[0] || null);
      }
    } catch (error) {
      console.error("Error al obtener asociaciones:", error);
      manejarAlertas("error", "Error al obtener asociaciones.");
    }
  };

  return (
    <Layout style={{ display: "flex", flexDirection: "column" }}>
      <Footer
        style={{
          textAlign: "center",
          background: "#f0f2f5",
          padding: "20px 50px",
        }}
        className="footer"
      >
        <Row
          justify="space-between"
          align="middle"
          gutter={[16, 16]}
          style={{ minHeight: "auto" }} 
        >
          {/* Columna 1: Logo */}
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <img
              src={
                asociacionActiva?.imagen
                  ? `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${asociacionActiva.id}/IMAGENES/ASOCIACIONES/${asociacionActiva.imagen}`
                  : "/img/logo-mundo-piloto-footer.svg"
              }
              alt="Logo"
              style={{ width: "20%", height: "50px", objectFit: "contain" }}
            />
          </Col>

          {/* Columna 2: Iconos */}
          <Col
            xs={24}
            sm={12}
            md={8}
            lg={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 15,
            }}
          >
            <a
              href="https://www.instagram.com/mundo.piloto/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <FaInstagram className="iconos-footer" />
            </a>
            {/* <a
              href="https://www.facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
            >
              <FaFacebookF className="iconos-footer" />
            </a> */}
          </Col>

          {/* Columna 3: Enlace */}
          <Col
            xs={24}
            sm={24}
            md={8}
            lg={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Link to="/admin">Inicio</Link>
          </Col>
        </Row>
      </Footer>

      <Row style={{ justifyContent: "center", background: "#BA1721" }}>
        <a
          href="https://fasecuatro.com.ar/"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "white", padding: "0.5em", textDecoration: "none" }}
        >
          Diseñado y Desarrollado por Fase Cuatro SAS
        </a>
      </Row>
    </Layout>
  );
};
